module.exports = __webpack_public_path__ + "static/media/avatar@2x.2156bd2b.png";